/* ============================================================
   <lh-card> — 系列页自定义产品卡交互
   变体选择（色板/按钮）→ 换图、价格、可用性、加购变体联动
   加购提交由主题的 <product-form> 元素处理（AJAX + 抽屉）
   ============================================================ */
(function () {
  if (customElements.get('lh-card')) return;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    // 货币格式可能含 HTML（如 <span class=money>），textContent 写入前先剥掉标签
    var formatString = (format || '${{amount}}').replace(/<[^>]+>/g, '');
    if (!formatString.match(placeholderRegex)) formatString = '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  class LhCard extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-lh-variants]');
      if (!dataEl) return; // 单变体产品无需交互

      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.currencyCodeEnabled = this.dataset.currencyCodeEnabled === 'true';
      this.currencyCode = this.dataset.currencyCode || 'USD';
      this.textAtc = this.dataset.textAtc || 'Add to cart';
      this.textSoldout = this.dataset.textSoldout || 'Sold out';

      this.mainImage = this.querySelector('[data-main-image]');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare-price]');
      this.saleBadge = this.querySelector('[data-sale-badge]');
      this.idInput = this.querySelector('input[name="id"]');
      this.atcButton = this.querySelector('button[name="add"]');
      this.atcText = this.querySelector('[data-atc-text]');
      this.optionButtons = Array.prototype.slice.call(this.querySelectorAll('[data-option-value]'));

      // 初始选中 = 当前 input 里的变体
      var initial = this.findVariantById(Number(this.idInput && this.idInput.value));
      if (!initial) initial = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
      this.selected = initial ? this.variantOptions(initial) : {};

      var self = this;
      this.optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = Number(btn.dataset.position);
          if (self.selected[pos] === btn.dataset.value) return;
          self.selected[pos] = btn.dataset.value;
          self.resolveVariant(pos);
          self.update();
        });
      });

      this.update();
    }

    variantOptions(variant) {
      return { 1: variant.option1, 2: variant.option2, 3: variant.option3 };
    }

    findVariantById(id) {
      return this.variants.filter(function (v) { return v.id === id; })[0];
    }

    matches(variant, selected) {
      return (
        (selected[1] == null || variant.option1 === selected[1]) &&
        (selected[2] == null || variant.option2 === selected[2]) &&
        (selected[3] == null || variant.option3 === selected[3])
      );
    }

    // 以 changedPos 为锚点解析变体：精确匹配 → 该值下第一个可用 → 该值下任意
    resolveVariant(changedPos) {
      var self = this;
      var exact = this.variants.filter(function (v) { return self.matches(v, self.selected); })[0];
      if (exact) return;

      var optKey = 'option' + changedPos;
      var value = this.selected[changedPos];
      var candidates = this.variants.filter(function (v) { return v[optKey] === value; });
      var pick = candidates.filter(function (v) { return v.available; })[0] || candidates[0];
      if (pick) this.selected = this.variantOptions(pick);
    }

    currentVariant() {
      var self = this;
      return this.variants.filter(function (v) { return self.matches(v, self.selected); })[0];
    }

    update() {
      var variant = this.currentVariant();
      var self = this;

      // 选中态 + 可用性
      this.optionButtons.forEach(function (btn) {
        var pos = Number(btn.dataset.position);
        var value = btn.dataset.value;
        btn.classList.toggle('is-selected', self.selected[pos] === value);

        var probe = {};
        for (var k in self.selected) probe[k] = self.selected[k];
        probe[pos] = value;
        var hasAvailable = self.variants.some(function (v) {
          return self.matches(v, probe) && v.available;
        });
        btn.classList.toggle('is-unavailable', !hasAvailable);
      });

      // 颜色名
      var colorLabel = this.querySelector('[data-color-label]');
      if (colorLabel) {
        var colorOption = colorLabel.closest('[data-option-position]');
        var pos = Number(colorOption.dataset.optionPosition);
        colorLabel.textContent = this.selected[pos] || '';
      }

      if (!variant) return;

      // 图片
      if (this.mainImage && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
        if (this.mainImage.getAttribute('src') !== src) {
          this.mainImage.removeAttribute('srcset');
          this.mainImage.setAttribute('src', src);
        }
      }

      // 价格
      if (this.priceEl) {
        if (this.currencyCodeEnabled) {
          this.priceEl.innerHTML = '<span class="currency-code">' + this.currencyCode + '</span>' + formatMoney(variant.price, '{{amount}}');
        } else {
          this.priceEl.textContent = formatMoney(variant.price, this.moneyFormat);
        }
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceEl.classList.toggle('is-sale', !!onSale);
        if (this.compareEl) {
          if (onSale) {
            if (this.currencyCodeEnabled) {
              this.compareEl.innerHTML = '<span class="currency-code">' + this.currencyCode + '</span>' + formatMoney(variant.compare_at_price, '{{amount}}');
            } else {
              this.compareEl.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
            }
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }
        if (this.saleBadge) {
          if (onSale) {
            var discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            this.saleBadge.textContent = '-' + discount + '%';
            this.saleBadge.hidden = false;
          } else {
            this.saleBadge.hidden = true;
          }
        }
      }

      // 加购表单
      if (this.idInput) this.idInput.value = variant.id;
      if (this.atcButton) {
        this.atcButton.disabled = !variant.available;
        if (this.atcText) this.atcText.textContent = variant.available ? this.textAtc : this.textSoldout;
      }
    }
  }

  customElements.define('lh-card', LhCard);
})();